module.exports = __webpack_public_path__ + "static/media/search-10.0a423794.png";